module.exports = __webpack_public_path__ + "static/school_support_img3@2x-e29f9d7f24631774de04e89f0b625edd.jpg";